import { Col, Row } from "antd";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import DriverClassificationContext from "../../../context/driver-classification/context";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";

interface IProps {}

const DriverClassificationFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(DriverClassificationContext);

  const calculatingOptions = [
    { label: t("yes"), value: true },
    { label: t("no"), value: false },
  ];

  const bonusEnabledOptions = [
    { label: t("yes"), value: true },
    { label: t("no"), value: false },
  ];

  return (
    <Form
      formId="driver-classification-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.calculatingDeliveryCostPerKilometer !== undefined &&
            data?.calculatingDeliveryCostPerKilometer !== null
              ? {
                  name: "calculatingDeliveryCostPerKilometer",
                  value: data.calculatingDeliveryCostPerKilometer,
                  operation: "eq",
                }
              : undefined,
            data?.extraOrderFixedBonusEnabled !== undefined &&
            data?.extraOrderFixedBonusEnabled !== null
              ? {
                  name: "extraOrderFixedBonusEnabled",
                  value: data.extraOrderFixedBonusEnabled,
                  operation: "eq",
                }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="calculatingDeliveryCostPerKilometer"
            label={`${t("calculating_delivery_cost_per_kilometer")}`}
            width="large"
            input={{
              type: "select",
              options: calculatingOptions,
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="extraOrderFixedBonusEnabled"
            label={`${t("extra_order_fixed_bonus_enabled")}`}
            width="large"
            input={{
              type: "select",
              options: bonusEnabledOptions,
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default DriverClassificationFilter;